import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { SolicitacaoBens } from 'src/app/_core/models/solicitacao-bens';
import { CadastroBemService } from 'src/app/_core/services/cadastro-bem.service';
import { PermissaoService } from 'src/app/_core/services/permissao.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { Usuario } from 'src/app/_core/models/usuario';
import { LoginService } from 'src/app/_core/services/login.service';
import { debounceTime } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-solicitacao-bens-modal',
  templateUrl: './solicitacao-bens-modal.component.html',
  styleUrls: ['./solicitacao-bens-modal.component.scss']
})
export class SolicitacaoBensModalComponent implements OnInit {
  @Input() public nR_BPM_BEM_PATRIMONIAL!: number;
  form:FormGroup;
  solicitacao:SolicitacaoBens;
  cadastro:CadastroBem[];
  user:Usuario;
  loading = true;
  keywordMeusBens='dS_BPM_DESCRICAO_BEM';
  keywordMatricula = 'nome';
  data:Usuario[];
  title = 'Tela de Solicitação de Bem';
  constructor(
    private fb:FormBuilder,
    public activeModal: NgbActiveModal,
    public datePipe:DatePipe,
    public modalService: NgbModal,
    private cadastroBemService: CadastroBemService,
    private loginService:LoginService,) { }

  ngOnInit() {
    this.loading = false;
    this.listarBensById();
    this.solicitacao = new SolicitacaoBens();
    this.createForm(this.solicitacao);
    this.user = JSON.parse(localStorage.getItem('currentUser')!);
    this.listarMeusBensById();
    this.listarUser();
  }
  onChange() {
    this.loading = true;
    //console.log/this.form.get('cD_BPM_NR_BEM_PATRIMONIAL')?.value);

    if (this.form.get('cD_BPM_NR_BEM_PATRIMONIAL')?.value.toString().length > 0) {
      this.cadastroBemService.listarBensById(this.form.get('cD_BPM_NR_BEM_PATRIMONIAL')?.value)
        .subscribe(
          data => {
            this.form.get('dS_BPM_DESCRICAO_BEM')?.setValue(data["dS_BPM_DESCRICAO_BEM"]);
            this.form.get('dS_BPM_NUMERO_SERIE')?.setValue(data["dS_BPM_NUMERO_SERIE"]);
            this.form.get('dS_BPM_MARCA')?.setValue(data["dS_BPM_MARCA"]);
            this.form.get('dS_BPM_MODELO')?.setValue(data["dS_BPM_MODELO"]);
            this.form.get('dS_BPM_OUTROS')?.setValue(data["dS_BPM_OUTROS"]);
            this.form.get('cD_CDU_MATRICULA_SOLICITACAO')?.setValue(data["cD_CDU_MATRICULA_SOLICITACAO"]);
            this.loading = false;
          }

        )
    }
  }
  createForm(solicitacao:SolicitacaoBens){
    this.form = this.fb.group({
      cD_BPM_NR_BEM_PATRIMONIAL: [solicitacao.cD_BPM_NR_BEM_PATRIMONIAL,],
      dS_BPM_DESCRICAO_BEM: [solicitacao.dS_BPM_DESCRICAO_BEM,[Validators.required]],
      dS_BPM_NUMERO_SERIE: [solicitacao.dS_BPM_NUMERO_SERIE,[]],
      dS_BPM_MARCA: [solicitacao.dS_BPM_MARCA,[]],
      dS_BPM_MODELO: [solicitacao.dS_BPM_MODELO,[]],
      dS_BPM_OUTROS: [solicitacao.dS_BPM_OUTROS,[]],
      cD_CDU_MATRICULA_SOLICITACAO: [solicitacao.dS_BPM_OUTROS,[Validators.required]],
      fL_ATIVO: [1,[]],
      fL_DELETADO: [0,[]],
    })
  }
  selectMeusBens(item:any) {
    //console.log/item)
    const num = JSON.stringify(item.nR_BPM_BEM_PATRIMONIAL);
    const desc = item.dS_BPM_DESCRICAO_BEM;
    this.nR_BPM_BEM_PATRIMONIAL = item.nR_BPM_BEM_PATRIMONIAL;
    this.form.get('cD_BPM_NR_BEM_PATRIMONIAL')?.setValue(num);
    this.form.get('dS_BPM_DESCRICAO_BEM')?.setValue(desc);
    this.ngOnInit();
  }
  // selectDest(item:any) {
  //   //console.log/item);
  //   const num = item.cD_MATRICULA;
  //   this.form.get('cD_CDU_MATRICULA_SOLICITACAO')?.setValue(num)
  // }
    listarMeusBensById(){
    this.cadastroBemService.listarMatById(this.user.cD_MATRICULA)
    .subscribe(
      data => {
               this.cadastro = data;
               this.cadastro.map( data => data.dS_BPM_DESCRICAO_BEM = ` ${data.nR_BPM_BEM_PATRIMONIAL} | ${data.dS_BPM_DESCRICAO_BEM}`);
             }
    )
  }
  listarBensById() {
    if (this.nR_BPM_BEM_PATRIMONIAL != 0) {
      this.cadastroBemService.listarBensById(this.nR_BPM_BEM_PATRIMONIAL)
        .subscribe(
          data => {
            this.solicitacao = data;
            this.createForm(this.solicitacao);
           
          }

        )
    }
  }
  listarUser(){
    setTimeout(()=>{
      this.loginService.getAll()
      .pipe(debounceTime(400)).subscribe(
        data=> {
          this.data = data;
          this.data.map( data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
        }
      )
    },300)
     

   
  }
  submit(){
    var sol = this.form.value;
    //console.log/sol);
    this.cadastroBemService.insertSolicitacao(sol).subscribe(
      data=>{
        Swal.fire(
          'Adicionado!',
          'Solicitação adicionada com sucesso!',
          'success'
        ).then(() => {
          this.loading = false;
          this.activeModal.close();
        });
      },
      err =>{
        this.loading = false;
      }
    )
  }
}
